<template>
    <div>
        <!-- Footer -->
        <div class="footer mt-3" :class="isMobile ? 'footer-sm' : 'footer-lg'" v-if="$route.path !== '/maung-fb' && $route.path !== '/body-fb'">
            <!-- <img src="/build/assets/img/brand/khit_thit.jpg" alt="" /> -->
            <div class="align-items-center justify-content-lg-between">
                <div class="col-lg-12 text-center">
                    <ul class="nav nav-footer justify-content-between">
                        <div class="d-flex justify-content-between" style="width: 35%;">
                            <li
                                class="nav-item"
                                @click="$router.push('/home')"
                                
                            >
                                <div class="d-flex flex-column banking-icons">
                                    <img  class="mx-auto" :src="linkIsActive('/home') ? '/images/711b4336890307ed.avif' : '/images/7e33fde26f35b4b0.avif'" style="width: auto; height: 2rem;" alt="">
                                    <div class="mx-auto pt-1 text-sm footer-text" style="color: #adacb1;">
                                        {{$t('footer.home')}}
                                    </div>
                                </div>
                            </li>
                            
                            <!-- <li
                                class="nav-item"
                                @click="openModal()"
                            >
                                <div class="d-flex flex-column banking-icons">
                                    <img class="mx-auto" src="/build/assets/img/icons/Download.png" style="width: 18px; height: 18px" alt="">
                                    <div class="mx-auto pt-1 text-sm" style="color: #a486ea;">
                                        {{
                                            $store.state.language === "en"
                                                ? "Download"
                                                : "ဒေါင်းလုတ်"
                                        }}
                                    </div>
                                </div>
                            </li> -->
                            <!-- -->
                            <!-- <li
                                class="nav-item"
                                @click="$router.push('/promotion')"
                                
                            >
                                <div class="d-flex flex-column banking-icons">
                                    <img class="mx-auto" :src="linkIsActive('/promotion') ? '/images/c66367f29aea916f.avif' : '/images/a7cfdb70098c91db.avif'" style="width: auto; height: 2rem;" alt="">
                                    <div :class="linkIsActive('/promotion') ? 'active' : ''" class="mx-auto pt-1 text-sm footer-text" style="color: #adacb1;">
                                        {{$t('footer.promotion')}}
                                    </div>
                                </div>
                            </li> -->
                            <li
                                class="nav-item"
                                @click="$router.push('/promotion')"
                            >
                                <div class="d-flex flex-column banking-icons">
                                    <img class="mx-auto" :src="linkIsActive('/promotion') ? '/images/93f327fa7a0a7ee4.avif' : '/images/ab1b81e220ab85e8.avif'" style="width: auto; height: 2rem;" alt="">
                                    <div class="mx-auto pt-1 text-sm footer-text" style="color: #adacb1;">
                                        {{$t('footer.promotion')}}
                                    </div>
                                </div>
                            </li>
                        </div>

                        <!-- <li
                            class="nav-item"
                            @click="$router.push('/history')"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img class="mx-auto" src="/images/e6b48001475f8df2.avif" style="width: auto; height: 2rem;" alt="">
                                <div class="mx-auto pt-1 text-sm" style="color: #adacb1000;">
                                    {{$t('setting.transaction')}}
                                </div>
                            </div>
                        </li> -->

                        <li
                            class="nav-item customize-icon"
                            style="position: absolute; left: 0; right: 0; top: -3rem !important; background: grey; width: 5rem;"
                            @click="$router.push('/user/slots?provider=Pragmatic')"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img class="mx-auto"  src="/images/69c82343006863d0.avif" style="width: auto; height: 4rem;" alt="">
                                <!-- <div class="mx-auto pt-1 text-sm footer-text" style="color: #adacb1;">
                                    {{$t('setting.transaction')}}
                                </div> -->
                            </div>
                        </li>

                        <div class="d-flex justify-content-between" style="width: 35%;">
                            <li
                                class="nav-item"
                                @click="$router.push('/deposit')"
                            >
                                <div class="d-flex flex-column banking-icons">
                                    <img class="mx-auto" :src="linkIsActive('/deposit') ? '/images/84cd0ef82ea443ef.avif' : '/images/913c5927f29bee5f.avif'" style="width: auto; height: 2rem;" alt="">
                                    <div class="mx-auto pt-1 footer-text" style="color: #adacb1; font-size: 0.8rem !important;">
                                        {{$t('setting.deposit')}}
                                    </div>
                                </div>
                            </li>

                            <li
                                class="nav-item"
                                @click="$router.push('/setting')"
                            >
                                <div class="d-flex flex-column banking-icons">
                                    <img class="mx-auto" :src="linkIsActive('/setting') ? '/images/bf0786471f9790ea.avif' : '/images/b178035cb124a2e3.avif'" style="width: auto; height: 2rem;" alt="">
                                    <div class="mx-auto pt-1 text-sm footer-text" style="color: #adacb1;">
                                        {{$t('footer.profile')}}
                                    </div>
                                </div>
                            </li>
                        </div>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Toast, Dialog } from 'vant';

export default {
  data() {
    return {
      is_live: false,
      isMobile: false,
    };
  },
  methods: {
    closeModal() {
      $('#download-modal').modal('hide');
    },
    openModal() {
      $('#download-modal').modal('show');
    },
    /* example link = '/settings' */
    linkIsActive(link) {
      console.log(this.$route.path === link);
      if (this.$route.path === link) return true;
      return false;
    },
    async fetchFootballLive() {
      try {
        const res = await axios.get('/football-lives');
        this.is_live = res.data.data[0].is_live;
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    // this.fetchFootballLive();
    if (window.innerWidth < 768) {
      this.isMobile = true;
    }
  },
};
</script>
<style scoped>

@keyframes x-jello-horizontal {
    0% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
    }
    5% {
        -webkit-transform: scale3d(1.25, .75, 1);
        transform: scale3d(1.25, .75, 1);
    }
    7.5% {
        -webkit-transform: scale3d(.75, 1.25, 1);
        transform: scale3d(.75, 1.25, 1);
    }
    10% {
        -webkit-transform: scale3d(1.15, .85, 1);
        transform: scale3d(1.15, .85, 1);
    }
    15% {
        -webkit-transform: scale3d(.95, 1.05, 1);
        transform: scale3d(.95, 1.05, 1);
    }
    20% {
        -webkit-transform: scale3d(1.05, .95, 1);
        transform: scale3d(1.05, .95, 1);
    }
    25%, 100% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
    }
}

.customize-icon {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    z-index: 2;
    width: 5.5rem !important;
    height: 6rem;
    margin: 0 8px 16px;
    padding-bottom: 8px;
    color: #000;
    background: rgba(0, 0, 0, .8) !important;
    border-radius: 50%;
    left: 40% !important;
    /* box-shadow: 0 0 10px hsla(0, 0%, 100%, .1); */
    animation: x-jello-horizontal 3s infinite both;
    border: 1px solid #83651e;
}

.modal-content {
    border: 2px solid #714DC7;
}
td .fa-trash {
    color: red;
}
.modal-cross {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    padding-top: 3px;
    margin-left: auto;
    color: white;
    cursor: pointer;
    margin-right: -9px;
    margin-top: -9px;
    background: #714DC7;
}
.banking-icons {
    width: auto;
    height: auto;
    padding: 5px;
    border-radius: 5px;
}
.bet-container {
    position: fixed;
    bottom: 0;
    margin-bottom: 50px;
    width: 50px;
    /* right: 0; */
    left: 5px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0.25em;
    color: white;
    z-index: 100;
    visibility: visible;
    opacity: 1;
}
.nav-item {
    /* margin-left: 10px;
    margin-right: 10px; */
    /* border: 1px solid red; */
    font-size: 1rem;
    cursor: pointer;
    font-weight: 600;
    color: #adacb1 !important;
    min-width: 60px;
    /* height: 100px; */
}
/* .nav-item:hover,
.nav-item.active {
    border-radius: 5px;
    background: #02133E;
    color: red !important;
} */
/* @media (max-width: 767.98px) { */
    .footer {
        bottom: 0;
        height: 4.5rem !important;
        width: 100%;
        /* background: white;#F5C0C2 */
        background: #000000;
        box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
        /* border-top-left-radius: 5px;
        border-top-right-radius: 5px; */
        /* color: #000000; */
        /* border-top: 2px solid black; */
    }
    .footer-sm {
        position: fixed;
    }
    .footer-lg {
        position: absolute;
    }
    .banking-icons {
        width: auto;
        height: auto;
        padding: 0.2rem;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        border-radius: 3px;
    }
    .footer {
        padding: 1px !important;
    }
    /* .banking-icons img {
        width: 25px;
        height: 25px;
        border-radius: 3px;
    } */
/* } */
</style>
